export default function About() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Premium Quality',
      description: 'Every product is crafted with the finest materials and tested in real-world conditions'
    },
    {
      icon: 'ri-water-flash-line',
      title: 'Water Resistant',
      description: 'Advanced fabric technology keeps you dry and comfortable in any weather'
    },
    {
      icon: 'ri-sun-line',
      title: 'UV Protection',
      description: 'Built-in UPF 50+ sun protection for all-day fishing under the sun'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Eco-Friendly',
      description: 'Sustainable materials and practices that protect our waters for future generations'
    }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-4 tracking-tight">
            WHY CHOOSE AQUATEK
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-light">
            We're not just selling gear—we're equipping you for success on the water
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="text-center p-8 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <div className="inline-flex items-center justify-center w-20 h-20 bg-cyan-100 rounded-full mb-6">
                <i className={`${feature.icon} text-4xl text-cyan-600 w-10 h-10 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 uppercase tracking-wide">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Story Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/ba69034b928adff4391264aeb11bb899.jpg"
              alt="Our Story"
              className="w-full h-96 object-cover object-top rounded-lg shadow-xl"
            />
          </div>
          <div>
            <p className="text-cyan-600 font-bold text-sm uppercase tracking-widest mb-4">
              Our Story
            </p>
            <h3 className="text-4xl font-black text-gray-900 mb-6 leading-tight">
              BUILT BY ANGLERS,
              <br />
              FOR ANGLERS
            </h3>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              AQUATEK was born from a simple frustration: fishing gear that looked great but failed when it mattered most. We set out to change that.
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Every product we create is tested by professional anglers in the harshest conditions. From tropical flats to deep sea adventures, our gear performs when you need it most.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              We're not just a brand—we're a community of passionate anglers committed to excellence on the water.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}